import React, { useState } from "react";
import styles from "./ElixirJourney.module.scss";
import { getCDNImageUrl } from "@/utils/Common";
import VideoLightbox from "./VideoLightbox";

const VIDEO_ID = "h_cnSSzGknU";

function ElixirJourney() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const openVideo = () => setIsVideoOpen(true);

  return (
    <section className={styles.journey}>
      <div className={styles.inner}>
        {/* Left: copy + CTA */}
        <div className={styles.content}>
          <div className={styles.copy}>
            <span className={styles.eyebrow}>PLATFORM DEMO</span>
            <div className={styles.headingBlock}>
              <h2 className={styles.heading}>
                See A Chemical Order Move, End To End
              </h2>
              <p className={styles.body}>
                Two minutes inside the Elchemy platform. Enquiry to quote, quote
                to cargo, with live tracking and documents in one place.
              </p>
            </div>
          </div>
          <button
            type="button"
            className={styles.watchButton}
            onClick={openVideo}
          >
            Watch The Demo
          </button>
        </div>

        {/* Right: journey illustration + play button */}
        <div className={styles.media}>
          <img
            src={getCDNImageUrl("journey-bg.webp")}
            alt="Elixir order journey: Product to Customer"
            className={styles.bg}
            loading="lazy"
          />
          <button
            type="button"
            className={styles.playButton}
            onClick={openVideo}
            aria-label="Play walkthrough video"
          >
            <img src="/assets/icons/elchemy-tech/play.svg" alt="" />
          </button>
        </div>
      </div>

      <VideoLightbox
        open={isVideoOpen}
        videoId={VIDEO_ID}
        onClose={() => setIsVideoOpen(false)}
      />
    </section>
  );
}

export default ElixirJourney;
